import React, {useState } from "react";
import { QRCode } from 'react-qrcode-logo';
import Snackbar from '@material-ui/core/Snackbar'

const QRCodeView = ({ invoice, amount, number}) => {
  const [open, setOpen] = useState(false);

  async function copyTextToClipboard(text) {
    setOpen(true);
    setTimeout(()=>{
      setOpen(false);
    },1000);
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  console.log('invoice', invoice, amount)
  return (
  <div>
    <h1 className="mb-2 text-center text-mg dark:text-jacarta-200 font-bold">
    {amount} SATS 입금하시면 기프트콘 쿠폰이 {number}개 발행됩니다.
    </h1>
    <h3 className="mb-2 text-center text-mg dark:text-jacarta-200 font-bold">(1개당 {Math.floor(amount/number)} SATS) </h3>
    <a onClick={()=>{copyTextToClipboard(invoice)}}>
    <h3 className="font-display text-jacarta-700 py-2 text-center text-1xl font-medium dark:text-white">
    invoice 복사하기
    </h3>            
    </a>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <QRCode
      ecLevel="H"
      value={invoice}
      size={300}
      logoImage="images/trading/bitcoin.png"
      logoWidth={50}
      />    
    </div>
    <Snackbar open={open} message="Copied."/>
  </div>
  );
}

export default QRCodeView;
